import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import * as _ from 'lodash';
import { distributionAssetsOptions } from '../../services/ref';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'assessment-assets-form',
    templateUrl: './assessment-assets-form.component.html',
    styleUrls: ['./assessment-assets-form.component.scss'],
    standalone: false
})
export class AssessmentAssetsFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = distributionAssetsOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor, subscriptionFacade);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  floored(value) {
    return Math.round(value * 100) / 100;
  }
  get repartition() {
    return this.form.value;
  }
  get totalAllocated() {
    const amount = _.pick(this.form.value, [
      'realEstateInvestment.percent',
      'liquidity.percent',
      'professionalAssets.percent',
      'realEstateUse.percent',
      'financialAssets.percent',
    ]);

    return (
      this.floored(
        _.chain(_.sum(_.values(amount).map(el => +el.percent))).value(),
      ) / 100
    );
  }
  get allocationPanel() {
    if (this.totalAllocated > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          this.totalAllocated * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% `,
      };
    else if (this.totalAllocated < 1)
      return {
        display: 'warning',
        icon: 'warning',

        text: `Il vous reste ${Math.round(
          (1 - this.totalAllocated) * 100,
        )}% à répartir
        `,
        // , soit ${
        //   this.form.value.amount * Math.round((1 - this.totalAllocated) * 100)
        // }€
      };
    else if (this.totalAllocated == 1)
      return {
        display: 'success',
        icon: 'check',
        text: 'Félicitations, vos revenus sont répartis à 100%',
      };
    // else
    //   return {
    //     display: "danger",
    //     icon: "error",
    //     text: "Vous ne pouvez pas repartir 0% dans un support",
    //   };
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    if (this.form.valid) {
      const pledge = this.subscriptionFacade.getPledge();
      if (pledge?.owners?.[0]) {
        pledge.owners[0].riskProfil.patrimonyDistribution = [
          'PROFESSIONAL_ASSETS',
        ];
        if (this.totalAllocated == 1) {
          this.subscriptionFacade.submitPledge(this);
        }
      }
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
